import React, { useState, useEffect } from 'react';
import { Layers, Car, FileText, List, Wrench, XCircle } from 'lucide-react';
import { vehiculosService } from '../../../services/api';
import VehiculosTab from './components/VehiculosTab';
import OrdenesTrabajoTab from './components/OrdenesTrabajoTab';
import OrdenesTrabajoList from './components/OrdenesTrabajoList';
import ManoObraTab from './components/ManoObraTab';
import OrdenesRechazadasTab from './components/OrdenesRechazadasTab';

const MultiServiciosView = () => {
  const [activeTab, setActiveTab] = useState('vehiculos');
  const [vehiculos, setVehiculos] = useState([]);

  useEffect(() => {
    const fetchVehiculos = async () => {
      try {
        const res = await vehiculosService.getAll({});
        const data = res?.data || res || [];
        setVehiculos(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error('Error cargando vehículos:', error);
      }
    };
    fetchVehiculos();
  }, []);

  return (
    <div className="p-2 md:p-6 space-y-6">
      <div>
        <h2 className="text-xl lg:text-2xl font-bold text-gray-800 flex items-center gap-2">
          <Layers className="text-blue-600" />
          Multi-Servicios
        </h2>
        <p className="text-sm lg:text-base text-gray-600">
          Gestione el almacén de vehículos, genere órdenes de trabajo y administre servicios.
        </p>
      </div>

      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-6 overflow-x-auto" aria-label="Tabs">
          <button
            onClick={() => setActiveTab('vehiculos')}
            className={`
              whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm flex items-center gap-2 transition-colors
              ${activeTab === 'vehiculos'
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }
            `}
          >
            <Car size={18} />
            Almacén de Vehículos
          </button>
          
          <button
            onClick={() => setActiveTab('ordenes')}
            className={`
              whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm flex items-center gap-2 transition-colors
              ${activeTab === 'ordenes'
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }
            `}
          >
            <FileText size={18} />
            Crear Orden
          </button>

          <button
            onClick={() => setActiveTab('lista_ordenes')}
            className={`
              whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm flex items-center gap-2 transition-colors
              ${activeTab === 'lista_ordenes'
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }
            `}
          >
            <List size={18} />
            Lista de Órdenes
          </button>

          <button
            onClick={() => setActiveTab('mano_obra')}
            className={`
              whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm flex items-center gap-2 transition-colors
              ${activeTab === 'mano_obra'
                ? 'border-amber-500 text-amber-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }
            `}
          >
            <Wrench size={18} />
            Mano de Obra
          </button>

          <button
            onClick={() => setActiveTab('rechazadas')}
            className={`
              whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm flex items-center gap-2 transition-colors
              ${activeTab === 'rechazadas'
                ? 'border-red-500 text-red-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }
            `}
          >
            <XCircle size={18} />
            Rechazadas
          </button>
        </nav>
      </div>

      <div className="pt-2">
        {activeTab === 'vehiculos' && (
          <VehiculosTab vehiculos={vehiculos} setVehiculos={setVehiculos} />
        )}
        {activeTab === 'ordenes' && (
          <OrdenesTrabajoTab vehiculos={vehiculos} />
        )}
        {activeTab === 'lista_ordenes' && (
          <OrdenesTrabajoList />
        )}
        {activeTab === 'mano_obra' && (
          <ManoObraTab />
        )}
        {activeTab === 'rechazadas' && (
          <OrdenesRechazadasTab />
        )}
      </div>
    </div>
  );
};

export default MultiServiciosView;
